import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Account, Company } from "../../../../generated/types";
import { sectionToIcon } from "../../../type/default";
import { DetailCard, InfoRow } from "./DetailCard";

const joinFilled = (values: (string | undefined)[], separator: string) =>
  values.filter(Boolean).join(separator);

/** Fiche élevage vue par un installateur : l'entreprise cliente et ses comptes éleveurs. */
export const ClientCard = ({
  company,
  accounts,
}: {
  company: Company;
  accounts: Account[];
}) => {
  const { t } = useTranslation();
  const address = joinFilled(
    [
      company.address,
      company.address_complementary,
      joinFilled([company.zip_code, company.city], " "),
    ],
    ", "
  );

  return (
    <DetailCard
      title={t("breeding-client-title")}
      icon={sectionToIcon.section_partnerships}
    >
      <dl>
        <InfoRow label={t("company-name")} value={company.company_name} />
        <InfoRow label={t("company-address")} value={address} />
        <InfoRow
          label={t("company-phone-mobile")}
          value={company.phone_mobile}
        />
        <InfoRow label={t("company-phone-fixe")} value={company.phone_fixe} />
        <InfoRow label={t("company-email")} value={company.email} />
      </dl>

      <h3 className="mt-4 mb-2 text-sm font-oxaniumMedium text-grey-medium">
        {t("breeding-client-accounts")}
      </h3>
      {accounts.length === 0 ? (
        <p className="text-sm text-grey-medium italic">
          {t("breeding-client-no-account")}
        </p>
      ) : (
        <ul className="space-y-2">
          {accounts.map((account) => (
            <li
              key={account.id}
              className="rounded-lg bg-grey-light/60 px-3 py-2 text-sm"
            >
              <div className="flex items-center gap-2 font-oxaniumMedium">
                <FontAwesomeIcon icon="user" className="text-secondary" />
                {joinFilled([account.first_name, account.last_name], " ") ||
                  "-"}
              </div>
              {account.email && (
                <a
                  href={`mailto:${account.email}`}
                  className="block mt-1 text-secondary underline break-all"
                >
                  {account.email}
                </a>
              )}
              {[account.phone_mobile, account.phone_fixe]
                .filter(Boolean)
                .map((phone) => (
                  <a
                    key={phone}
                    href={`tel:${phone}`}
                    className="block mt-1 text-default-text"
                  >
                    {phone}
                  </a>
                ))}
            </li>
          ))}
        </ul>
      )}
    </DetailCard>
  );
};
